import moment from "moment";
import React from "react";

import {ColumnProps} from "types/models";
import {FIELD_TYPE, FORMAT_TIME, tabKeys} from "types/enums";
import {listGender} from "data/list";
const {INPUT, SELECT, DATE, NUMBER, COMBO_BOX} = FIELD_TYPE;

const inputFields: any[] = [
  {
    type: INPUT,
    label: "Mã phiếu khám",
    name: "maKB",
    expand: false,
  },
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
    expand: false,
  },
  {
    type: INPUT,
    name: "id",
    label: "Mã đơn thuốc kê",
    expand: false,
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái đơn",
    name: "status",
    // default: "CB",
    options: [
      {value: "CB", label: "Chưa cấp phát"},
      {value: "DB", label: "Đã cấp phát"},
    ],
    expand: false,
  },
  {
    type: INPUT,
    label: "Tên bệnh nhân",
    name: "hoTen",
    expand: false,
  },
  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinh",
    expand: false,
  },

  {
    type: SELECT,
    label: "Giới tính",
    name: "gioiTinh",
    expand: true,
    options: listGender,
  },
  {
    type: INPUT,
    label: "Số thẻ BHYT",
    name: "soTheBHYT",
    expand: true,
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "dienThoai",
    expand: true,
  },
  {
    type: DATE,
    label: "Ngày tạo từ",
    name: "startNgayTao",
    expand: true,
  },
  {
    type: DATE,
    label: "Ngày tạo đến",
    name: "endNgayTao",
    expand: true,
  },

  // {
  //   type: SELECT,
  //   label: "Trạng thái đơn thuốc",
  //   expand: [{value:'CB'}],
  // },
];
const allColumns: ColumnProps[] = [
  {
    key: "index",
    title: "STT",
    show: true,
    dataIndex: "index",
    render(value, record, index) {
      return <>{index + 1}</>;
    },
    align: "center",
  },
  {
    key: "maBenhNhan",
    title: "Mã bệnh nhân",
    show: true,
    dataIndex: "maBenhNhan",
  },
  {
    title: "Mã phiếu khám",
    key: "maKB",
    show: true,
    dataIndex: "maKB",
  },
  {
    title: "Mã đơn thuốc",
    key: "donKeId",
    show: true,
    dataIndex: "donKeId",
  },
  {
    title: "Tên bệnh nhân",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
  },
  {
    title: "Ngày sinh",
    key: "ngaySinh",
    show: true,
    dataIndex: "ngaySinh",
    render(value, record, index) {
      return <>{value ? moment(value).format(FORMAT_TIME.dayFull) : null}</>;
    },
  },
  {
    title: "Giới tính",
    key: "gioiTinh",
    show: true,
    dataIndex: "gioiTinh",
    render(value, record, index) {
      return <>{value == "NA" ? "Nam" : "Nữ"}</>;
    },
  },
  {
    title: "Thời gian khám",
    key: "thoiGianKham",
    show: true,
    dataIndex: "thoiGianKham",
    render(value, record, index) {
      return <>{value ? moment(value).format(FORMAT_TIME.dateTime) : null}</>;
    },
  },
  {
    title: "Bác sĩ",
    key: "tenBacSy",
    show: true,
    dataIndex: "tenBacSy",
  },
  {
    title: "Trạng thái đơn",
    key: "status",
    show: true,
    render(value, record, index) {
      return <>{value == "CB" ? "Chưa cấp phát" : "Đã cấp phát"}</>;
    },
    dataIndex: "status",
  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    show: true,
    dataIndex: "ghiChu",
  },
];
export {allColumns, inputFields};
